import { createSlice, createAsyncThunk } from '@reduxjs/toolkit' // 👈️ Redux Imports
import axios from 'axios'// 👈️ Axios Imports
import { urlReportingService } from '@src/endpoints' // 👈️ API Microservice EndPoint
import { getUriParams } from '@src/utility/Utils' // 👈️ Utility

export const getData = createAsyncThunk('stuffing/getData', async params => {
  const uri = getUriParams(params)
  const ReportFilter = {
    fromDate: params.fromDate === '' ? null : params.fromDate,
    toDate: params.toDate === '' ? null : params.toDate,
    transloadOrderNumber: params.orderNumber === '' ? null : params.orderNumber,
    oceanBookingNumber: params.bookingNumber === '' ? null : params.bookingNumber,
    isOrganic: params.isOrganic || null,
    customerName: params.customerName === '' ? null : params.customerName,
    shippingLineCode: params.shippingLineCode === '' ? null : params.shippingLineCode,
    status: null //params.status?.value
  }
  const response = await axios.post(`${urlReportingService}/GetAllTransloadBookingReportList?${uri}`, ReportFilter)
  const responseData = await response.data.data
  
  return {
    params,
    data: responseData,
    filter: ReportFilter,
    totalPages: response.data.data.length > 0 ? response.data.totalCount : 0,
    loaded: true
  }
})

export const getStuffingReport = createAsyncThunk('stuffing/getStuffingReport', async (param) => {
   const response = await axios.get(`${urlReportingService}/GetTransloadBookingReport/${param.oid}/${param.bid}`)
  return {
    stuffingReport: response.data.data,
    vloaded: true
  }
})
// get railcar demurrage report
export const getRailcarDemurrageReport = createAsyncThunk('ReportingService/GetRailcarDemurrageReport', async (param) => {
  const response = await axios.get(`${urlReportingService}/GetRailcarDemurrageReport/${param.oid}/${param.bid}`)
  return {
    railcarDemurrageReport: response.data.data
  }
})

//get nova transload report
export const getNovaTransloadReport = createAsyncThunk('ReportingService/GetNovaTransloadReport', async (param) => {
  const response = await axios.get(`${urlReportingService}/GetNovaTransloadBookingReport/${param.PONumber}`)
   return {
    novaTransloadReport: response.data.data
  }
})
//get ctc transload report
export const getCTCTransloadReport = createAsyncThunk('ReportingService/GetCTCTransloadReport', async (id) => {
  const response = await axios.get(`${urlReportingService}/GetCTCTransloadReport/${id}`)
    return {
      selectedCTCtransloadReport: response.data.data
    }
})

//GET SPECIAL CUSTOMERS BY CUSTOMER CODE
export const getSpecialCustomersByCustomerCode = createAsyncThunk('specialCustomer/getSpecialCustomersByCustomerCode', async customerCode => {
  const response = await axios.get(`${urlReportingService}/GetSpecialReport/${customerCode}`)
   return {
    ctcIntactReport: response.data.data
     }
})
//GET INTACT REPORT BY BILLING PERIOD
export const getIntactReportByBillingPeriod = createAsyncThunk('specialCustomer/getIntactReportByBillingPeriod', async (billingPeriod) => {
   const response = await axios.get(`${urlReportingService}/GetCTCIntactReport/${billingPeriod}`)
    return {
      selectedReportbyBillingPeriod: response.data.data
  }
})
//get lift storage report by billing period
export const getLiftStorageReportByBillingPeriod = createAsyncThunk('specialCustomer/getLiftStorageReportByBillingPeriod', async (billingPeriod) => {
  const response = await axios.get(`${urlReportingService}/GetCTCLiftStorageReport/${billingPeriod}`)
  return {
    selectedLiftStorageReportbyBillingPeriod: response.data.data
  }
})

// export const updateStuffingReport = async (data) => {
//   const response = await axios.post(`${urlReportingService}/AddOrUpdateTransloadBookingReport`, data)
//   if (response.data.success) {
//     return { success: true, data: response.data.data }
//   } else {
//     return { success: false, message: response.data.messages }
//   }
// }

export const setValidation = async ({ reports, isValid, lastModifiedBy, excelFiles = [] }) => {
  const formData = new FormData()

  formData.append('model', JSON.stringify({ reports, isValid, lastModifiedBy }))

  excelFiles.forEach((file) => {
    if (file) {
      formData.append('excelFiles', file)
    } else {
      formData.append('excelFiles', new Blob([]), '')
    }
  })

  const token = localStorage.getItem('accessToken')
  const response = await fetch(`${urlReportingService}/SetValidation`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`
    },
    body: formData
  })

  const json = await response.json()
  if (json.success) {
    return { success: true, data: json.data }
  } else {
    return { success: false, message: json.messages }
  }
}

export const regenerateReports = async (reportIds) => {
  const token = localStorage.getItem('accessToken')
  const response = await fetch(`${urlReportingService}/GenerateReport`, {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`
  },
    body: JSON.stringify(reportIds)
  })

  const json = await response.json()
  if (json.success) {
    return { success: true, data: json.data }
  } else {
    return { success: false, message: json.messages }
  }
}

export const stuffingSlice = createSlice({
  name: 'stuffing',
  initialState: {
    loaded: false,
    vloaded: false,
    verror: false,
    data: [],
    total: 1,
    params: {},
    stuffingReport: null,
    novaTransloadReport: null,
    ctcIntactReport: null,
    selectedReportbyBillingPeriod: null,
   selectedCTCtransloadReport: null,
   selectedLiftStorageReportbyBillingPeriod: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getData.pending, (state) => {
        state.loaded = false
        state.vloaded = false
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.loaded = action.payload.loaded
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
        state.filter = action.payload.filter
      })
      .addCase(getData.rejected, (state) => {
        state.loaded = true
        state.data = []
        state.total = 0
      })
      .addCase(getStuffingReport.fulfilled, (state, action) => {
        state.vloaded = action.payload.vloaded
        state.stuffingReport = action.payload.stuffingReport
      })
      .addCase(getStuffingReport.rejected, (state) => {
        state.vloaded = true
        state.verror = true
      })
      .addCase(getRailcarDemurrageReport.fulfilled, (state, action) => {
        state.vloaded = true
        state.railcarDemurrageReport = action.payload.railcarDemurrageReport
      })
      .addCase(getNovaTransloadReport.fulfilled, (state, action) => {
        state.vloaded = true
        state.novaTransloadReport = action.payload.novaTransloadReport
      })
      .addCase(getSpecialCustomersByCustomerCode.fulfilled, (state, action) => {
        state.vloaded = true
        state.ctcIntactReport = action.payload.ctcIntactReport
      })
      .addCase(getIntactReportByBillingPeriod.fulfilled, (state, action) => {
        state.vloaded = true
        state.verror = false
        state.selectedReportbyBillingPeriod = action.payload.selectedReportbyBillingPeriod
      })
      .addCase(getCTCTransloadReport.fulfilled, (state, action) => {
        state.vloaded = true
        state.selectedCTCtransloadReport = action.payload.selectedCTCtransloadReport
      })
      .addCase(getLiftStorageReportByBillingPeriod.fulfilled, (state, action) => {
        state.vloaded = true
        state.selectedLiftStorageReportbyBillingPeriod = action.payload.selectedLiftStorageReportbyBillingPeriod
      })
  }
})

export default stuffingSlice.reducer

stuffingSlice.metadata = {
  name: 'Zakeer Sainalabdeen',
  github: 'zakeerwtc',
  description: 'Stuffing Reports - Store {Get Data from Microservices}',
  filename: 'stuffing',
  githubFile: 'https://github.com/WTCGroup/Frontend/blob/main/src/views/apps/reports/store/stuffing.js',
  prodUrl: ''
}